// extracted by mini-css-extract-plugin
export default {"elementPane":"ElementPane_elementPane__f1pf-"};